/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ from: NonNullable<unknown> }} Workout_Swap_Scope_Today_NoteInputs */

const en_us2_workout_swap_scope_today_note = /** @type {(inputs: Workout_Swap_Scope_Today_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Your plan keeps ${i?.from}`)
};

const pt_br2_workout_swap_scope_today_note = /** @type {(inputs: Workout_Swap_Scope_Today_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O plano continua com ${i?.from}`)
};

const es_419_workout_swap_scope_today_note = /** @type {(inputs: Workout_Swap_Scope_Today_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tu plan sigue con ${i?.from}`)
};

const pt_pt2_workout_swap_scope_today_note = /** @type {(inputs: Workout_Swap_Scope_Today_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`O plano continua com ${i?.from}`)
};

const fr_fr2_workout_swap_scope_today_note = /** @type {(inputs: Workout_Swap_Scope_Today_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ton programme garde ${i?.from}`)
};

const de_de2_workout_swap_scope_today_note = /** @type {(inputs: Workout_Swap_Scope_Today_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dein Plan behält ${i?.from}`)
};

const it_it2_workout_swap_scope_today_note = /** @type {(inputs: Workout_Swap_Scope_Today_NoteInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`La scheda resta con ${i?.from}`)
};

/**
* | output |
* | --- |
* | "Your plan keeps {from}" |
*
* @param {Workout_Swap_Scope_Today_NoteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_swap_scope_today_note = /** @type {((inputs: Workout_Swap_Scope_Today_NoteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Swap_Scope_Today_NoteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_swap_scope_today_note(inputs)
	if (locale === "es-419") return es_419_workout_swap_scope_today_note(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_swap_scope_today_note(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_swap_scope_today_note(inputs)
	if (locale === "de-DE") return de_de2_workout_swap_scope_today_note(inputs)
	if (locale === "it-IT") return it_it2_workout_swap_scope_today_note(inputs)
	return en_us2_workout_swap_scope_today_note(inputs)
});
export { workout_swap_scope_today_note as "workout-swap.scope_today_note" }